/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Legal_Cookies_BodyInputs */

const en_legal_cookies_body = /** @type {(inputs: Legal_Cookies_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This policy explains the cookies and similar technologies Complete Athlete uses on your device. You can change your choice at any time with the cookie button in the corner of the page. You can also block or delete cookies in your browser, though sign-in will then stop working.

## 1. Strictly necessary

These are always on, because the app cannot work without them.

- **better-auth.session_token**: keeps you signed in, for the length of your session.
- **Sign-in with Google state cookies**: protect the Google sign-in, and last only for that sign-in.
- **PARAGLIDE_LOCALE**: remembers your language, for 400 days.
- **cc_cookie**: remembers your cookie choice.
- **sidebar_state**: remembers whether the side panel is open, for 7 days.

We also keep small settings in your browser's local storage, such as theme, panel width, your place in a booking and an invitation you are accepting. They stay on your device.

## 2. Analytics (only if you agree)

If you accept analytics, **PostHog** stores an identifier in your browser (a cookie starting with \`ph_\` and local storage) so we can see which pages are slow, broken or ignored. If you are signed in, your visits are tied to your account, including your email and name.

If you refuse, we still count page views and events without cookies or stored identifiers, and without tying them to you. If you later turn analytics off, the identifiers are cleared.

## 3. No advertising cookies

We do not use advertising or cross-site tracking cookies. If that changes, we will ask for your consent first.

## 4. Third parties

Maps load images from OpenStreetMap, which receives your IP address. **Stripe** sets its own cookies on its payment pages to prevent fraud. Error reports go to **Sentry** without cookies. These providers are described in our [Privacy Policy](/privacy).

## 5. Contact

Questions? Write to ${i?.email}.`)
};

const pl_legal_cookies_body = /** @type {(inputs: Legal_Cookies_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Niniejsza polityka wyjaśnia, jakich plików cookie i podobnych technologii Complete Athlete używa na Twoim urządzeniu. Swój wybór możesz zmienić w każdej chwili za pomocą przycisku plików cookie w rogu strony. Możesz też blokować lub usuwać pliki cookie w przeglądarce, ale wtedy logowanie przestanie działać.

## 1. Niezbędne

Te pliki są zawsze włączone, ponieważ bez nich aplikacja nie może działać.

- **better-auth.session_token**: podtrzymuje logowanie przez czas trwania Twojej sesji.
- **Pliki cookie stanu logowania przez Google**: chronią logowanie przez Google i działają tylko na czas tego logowania.
- **PARAGLIDE_LOCALE**: zapamiętuje Twój język przez 400 dni.
- **cc_cookie**: zapamiętuje Twój wybór dotyczący plików cookie.
- **sidebar_state**: zapamiętuje przez 7 dni, czy panel boczny jest otwarty.

W pamięci lokalnej przeglądarki przechowujemy też drobne ustawienia, takie jak motyw, szerokość panelu, Twoje miejsce w trakcie rezerwacji oraz zaproszenie, które akceptujesz. Pozostają one na Twoim urządzeniu.

## 2. Analityczne (tylko za Twoją zgodą)

Jeśli zaakceptujesz analitykę, **PostHog** zapisuje w Twojej przeglądarce identyfikator (plik cookie o nazwie zaczynającej się od \`ph_\` oraz pamięć lokalną), abyśmy mogli sprawdzać, które strony działają wolno, nie działają poprawnie lub są pomijane. Jeśli korzystasz z aplikacji po zalogowaniu, Twoje wizyty są powiązane z Twoim kontem, w tym z adresem e-mail oraz imieniem i nazwiskiem.

Jeśli odmówisz, nadal zliczamy wyświetlenia stron i zdarzenia, ale bez plików cookie i zapisanych identyfikatorów oraz bez łączenia ich z Tobą. Jeśli później wyłączysz analitykę, identyfikatory zostaną usunięte.

## 3. Brak reklamowych plików cookie

Nie używamy reklamowych plików cookie ani plików cookie śledzących między witrynami. Jeśli to się zmieni, najpierw poprosimy Cię o zgodę.

## 4. Podmioty trzecie

Mapy wczytują obrazy z OpenStreetMap, które otrzymuje Twój adres IP. **Stripe** ustawia na swoich stronach płatności własne pliki cookie, aby zapobiegać oszustwom. Raporty o błędach trafiają do **Sentry** bez plików cookie. Tych dostawców opisuje nasza [Polityka prywatności](/privacy).

## 5. Kontakt

Masz pytania? Napisz na adres ${i?.email}.`)
};

/**
* | output |
* | --- |
* | "This policy explains the cookies and similar technologies Complete Athlete uses on your device. You can change your choice at any time with the cookie button..." |
*
* @param {Legal_Cookies_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_cookies_body = /** @type {((inputs: Legal_Cookies_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Cookies_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_cookies_body(inputs)
	return en_legal_cookies_body(inputs)
});